import styled, { css } from 'styled-components';

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
`;

export const Col = styled.div`
  ${({ xs6 }) =>
    xs6 &&
    css`
      flex: 0 0 auto;
      width: 50%;
    `}
  ${({ xs12 }) =>
    xs12 &&
    css`
      flex: 0 0 auto;
      width: 100%;
    `}
  ${({ sm4 }) =>
    sm4 &&
    css`
      @media (min-width: 576px) {
        flex: 0 0 auto;
        width: 33.33333333%;
      }
    `}
  ${({ md12 }) =>
    md12 &&
    css`
      @media (min-width: 768px) {
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
      }
    `}
`;
